





















import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    items: Array,
  },
  setup() {
    return {};
  },
});
